
import store from '@store'

export default class Model {

  constructor() {
    this.$data = window.FrontendApi
  }

  get model() {
    return store.getters['store2/models']
  }

  get models() {
    return this.$data.models
  }

  request(_options) {
    const options = Object.assign({
      method: 'GET',
      url: '/api/test-status/200',
      data: {}
    }, _options)

    // this.$log(options)
    if (Array.isArray(options.url)) options.url = options.url.join('')

    // return Ambition.Request.call(options)

    return new Promise(async (resolve, reject) => {
      try {
        const response = await Ambition.Request.call(options)
        resolve(response)
      } catch (e) {
        this.$error(e)
        reject(e)
      }
    })
  }

  // Load EMPTY model
  emptyModel() {
    store.dispatch('store2/setModel', {
      model: model_name,
      value: null
    })
  }

  async create(model_name, query) {

    // Validate arguments
    if (!model_name) return this.$error('Model name not specified')
    if (!this.models[model_name]) return this.$error(`Model for "${model_name}" was not found`)
    if (!query) return this.$error('No data passed to $store2.load(model_name, data)')
    // if (!data.id) return this.$error('Need an { id: } to load the model')

    // Make the request
    this.request({
      method: 'PUT',
      url: '/api/v4/model',
      params: { model: model_name, query }
    }).then(({ data }) => {
      store.dispatch('store2/setModel', { model: model_name, value: data })
    }).catch((error) => {
    })
  }

  async select(model_name, query) {

    // Validate arguments
    if (!model_name) return this.$error('Model name not specified')
    if (!this.models[model_name]) return this.$error(`Model for "${model_name}" was not found`)
    if (!query) return this.$error('No data passed to $store2.load(model_name, data)')
    // if (!data.id) return this.$error('Need an { id: } to load the model')

    // Make the request
    this.request({
      method: 'GET',
      url: '/api/v4/model',
      // params: { model: model_name, query: { id: [130, 131] } }
      params: { model: model_name, query }
    }).then(({ data }) => {
      store.dispatch('store2/setModel', { model: model_name, value: data })
    }).catch((error) => {
    })
  }

  async update(model_name, where, query) {

    // If [where] is an array and [query] is undefined it's a collection of models instead of a single (default)
    let is_collection = Array.isArray(where) && typeof query === 'undefined'
    let is_single = !is_collection

    // If [where] and [query] are undefined, get data from store
    let use_store_data = typeof where === 'undefined' && typeof query === 'undefined'
    if (use_store_data) {
      const model = store.getters['store2/models'][model_name]
      // query = this.models[model_name]
      where = { 'id': model.id }
      query = model
    }

    // Validate and transpose arguments
    if (!model_name) return this.$error('Model name not specified')
    if (!this.models[model_name]) return this.$error(`Model for "${model_name}" was not found`)
    if (is_collection) {
      const collection = where
      if (collection.length == 0) return this.$error('No data passed to $store2.load(model_name, data)')
    }
    if (is_single) {
      if (!query) return this.$error('No data passed to $store2.load(model_name, data)')
    }

    // Make the request
    this.request({
      method: 'POST',
      url: '/api/v4/model',
      data: { model: model_name, where, query }
    }).then(({ data }) => {
      store.dispatch('store2/setModel', { model: model_name, value: data })
    }).catch((error) => {
    })

    // Load application into model
    // store.dispatch('store2/setModel', {
    //   model: 'Application',
    //   value: deepExtend(this.models['Application'], data)
    // })
  }

  async delete(model_name, query) {

    // Validate arguments
    if (!model_name) return this.$error('Model name not specified')
    if (!this.models[model_name]) return this.$error(`Model for "${model_name}" was not found`)
    if (!query) return this.$error('No data passed to $store2.load(model_name, data)')
    // if (!data.id) return this.$error('Need an { id: } to load the model')

    // Make the request
    this.request({
      method: 'DELETE',
      url: '/api/v4/model',
      data: { model: model_name, query }
    }).then(({ data }) => {
      store.dispatch('store2/setModel', { model: model_name, value: data })
    }).catch((error) => {
    })
  }
}
